import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { Button } from '@/components/ui/button';
import { FormError } from '@/components/ui/form-error';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const nameSchema = z.object({
  name: z.string().min(2, 'O nome deve ter pelo menos 2 caracteres'),
});

type NameFormValues = z.infer<typeof nameSchema>;

interface NameStepProps {
  defaultValue: string;
  onNext: (name: string) => void;
}

export function NameStep({ defaultValue, onNext }: NameStepProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<NameFormValues>({
    resolver: zodResolver(nameSchema),
    defaultValues: { name: defaultValue },
  });

  const onSubmit = (data: NameFormValues) => {
    onNext(data.name);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          Qual é o seu nome?
        </h1>
        <p className="text-muted-foreground text-sm">
          Esse nome aparecerá para o seu parceiro(a)
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="name">Nome</Label>
        <Input
          id="name"
          type="text"
          placeholder="Seu nome"
          autoComplete="name"
          autoFocus
          {...register('name')}
        />
        <FormError message={errors.name?.message} />
      </div>

      <Button type="submit" className="w-full">
        Continuar
      </Button>
    </form>
  );
}
